export enum CardColor {
  Black = "black",
  Gray = "gray",
  White = "white",
}
